import React, { useState } from 'react'
import Item from './Item'
import Collapsible from 'react-collapsible';

function Category({ category, isChildCat, image = "" }) {

    const [isOpen, setIsOpen] = useState(true);

    return (
        <div className="menu-list" id={category.cat_id}>
            <Collapsible open={true} trigger={<h2 className="category-name">
                {!isChildCat && <span className={isOpen ? 'fa fa-caret-down' : 'fa fa-caret-right'}></span>}
                <span>{category.category_name}</span>
                {/*image && <img src={image} alt="" />*/}
            </h2>} onOpen={() => setIsOpen(true)} onClose={() => setIsOpen(false)}>
                {category.items.map(item => <Item item={item} key={item.item_id} isSplCat={image} />)}
            </Collapsible>
        </div>
    )
}

export default Category
